import { render, staticRenderFns } from "./tkcarorders.vue?vue&type=template&id=4bb2ad7b&scoped=true&"
import script from "./tkcarorders.vue?vue&type=script&lang=js&"
export * from "./tkcarorders.vue?vue&type=script&lang=js&"
import style0 from "./tkcarorders.vue?vue&type=style&index=0&id=4bb2ad7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2ad7b",
  null
  
)

export default component.exports